import React from 'react'
import {ListCustomersContextProvider} from './../context/ListCustomersContext'
import ListCustomerPage from './ListCustomerPage'
import queryString from 'query-string'
import {setLocalData} from "../../../services/StorageServices";

function ListCustomersContainer(props) {
    const {history} = props
    const {location} = history
    let params = {}

    if (location.search !== '') {
        const _params = queryString.parse(location.search)

        if (_params.package_status !== undefined) {
            const valuePackageStatus = _params.package_status
            delete _params.package_status
            _params.package_status = valuePackageStatus.split(",")
        }
        params = Object.assign(_params, _params.suppliers !== undefined ? {suppliers: [_params.suppliers]} : {})
    } else {
        setLocalData('listCustomersFilters', {})
    }

    return <section className="ListCustomersContainer">
        <ListCustomersContextProvider params={params}>
            <ListCustomerPage/>
        </ListCustomersContextProvider>
    </section>
}

export default ListCustomersContainer
